import CreateDashboard from './CreateDashboard';
export default CreateDashboard;